var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h1',[_vm._v("Myproof customer agreement")]),_c('p',[_vm._v("Page under development")])])}]

export { render, staticRenderFns }